import AccountBoxIcon from '@mui/icons-material/AccountBox'
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter'
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
import CarRepairIcon from '@mui/icons-material/CarRepair'
import CarRepairOutlinedIcon from '@mui/icons-material/CarRepairOutlined'
import CommuteIcon from '@mui/icons-material/Commute'
import CommuteOutlinedIcon from '@mui/icons-material/CommuteOutlined'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import FeedIcon from '@mui/icons-material/Feed'
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined'
import GroupsIcon from '@mui/icons-material/Groups'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined'
import HubIcon from '@mui/icons-material/Hub'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import LeaderboardIcon from '@mui/icons-material/Leaderboard'
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'
import PaymentsIcon from '@mui/icons-material/Payments'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import PersonIcon from '@mui/icons-material/Person'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import ViewListIcon from '@mui/icons-material/ViewList'
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined'
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline'
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined'
import type SvgIcon from '@mui/material/SvgIcon'
import type { ComponentType } from 'react'

export type IconComponent = typeof SvgIcon

export const TimelineIcon = ViewTimelineIcon
export const StatisticsIcon = LeaderboardIcon
export const AccessGroupsIcon = GroupsIcon
export const DefaultResourceIcon = ViewListIcon

const outlinedByFilled = new Map<ComponentType, IconComponent>([
  [AccountBoxIcon, AccountBoxOutlinedIcon],
  [BusinessCenterIcon, BusinessCenterOutlinedIcon],
  [CarRepairIcon, CarRepairOutlinedIcon],
  [CommuteIcon, CommuteOutlinedIcon],
  [DirectionsCarIcon, DirectionsCarOutlinedIcon],
  [EventAvailableIcon, EventAvailableOutlinedIcon],
  [FeedIcon, FeedOutlinedIcon],
  [GroupsIcon, GroupsOutlinedIcon],
  [HealthAndSafetyIcon, HealthAndSafetyOutlinedIcon],
  [HubIcon, HubOutlinedIcon],
  [LeaderboardIcon, LeaderboardOutlinedIcon],
  [LocalOfferIcon, LocalOfferOutlinedIcon],
  [LocationOnIcon, LocationOnOutlinedIcon],
  [ManageAccountsIcon, ManageAccountsOutlinedIcon],
  [MonetizationOnIcon, MonetizationOnOutlinedIcon],
  [PaymentsIcon, PaymentsOutlinedIcon],
  [PersonIcon, PersonOutlinedIcon],
  [ReceiptLongIcon, ReceiptLongOutlinedIcon],
  [ViewListIcon, ViewListOutlinedIcon],
  [ViewTimelineIcon, ViewTimelineOutlinedIcon],
])

export const getOutlinedIcon = (icon: ComponentType): IconComponent | undefined => outlinedByFilled.get(icon)
